import { forwardRef, useCallback, useEffect, useState } from 'react'
import { Modal, Table } from 'react-bootstrap'
import { CustomSpinner } from '../../../components/CustomSpinner'

import HistoricoSaldoService from '../../../services/database/HistoricoSaldoService'

import { toast } from 'react-toastify'
import noBalanceImg from '../../../assets/illustration/no-balance.svg'
import { formatPrice } from '../../../utils/formatPrice'

import './styles.css'

export const ModalHistoricoSaldo = forwardRef(
  ({ isOpen, onClose, pessoa }, ref) => {
    const [historico, setHistorico] = useState([])
    const [isLoadingHistorico, setIsLoadingHistorico] = useState(false)

    const loadHistorico = useCallback(async () => {
      setIsLoadingHistorico(true)

      try {
        const historicoData = await HistoricoSaldoService.getByIDCliente(
          pessoa.cod_pessoa,
        )

        setHistorico(historicoData)
      } catch (err) {
        console.log(`Erro ao carregar o histórico: ${err}`)

        toast.error('Erro ao carregar o histórico, tente novamente mais tarde!')
      } finally {
        setIsLoadingHistorico(false)
      }
    }, [pessoa.cod_pessoa])

    useEffect(() => {
      loadHistorico()
    }, [loadHistorico])

    return (
      <Modal
        ref={ref}
        show={isOpen}
        onHide={onClose}
        dialogClassName="modal-historico-saldo-dialog"
      >
        <Modal.Header closeButton>
          <Modal.Title
            style={{
              fontSize: 20,
            }}
          >
            Histórico de Alteração de Saldo
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {isLoadingHistorico ? (
            <div
              style={{
                gap: 10,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <CustomSpinner />
            </div>
          ) : !isLoadingHistorico && historico.length === 0 ? (
            <div
              style={{
                gap: 10,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <h1
                style={{
                  fontSize: 20,
                }}
              >
                Não há dados a serem exibidos!
              </h1>

              <img
                src={noBalanceImg}
                style={{
                  width: 200,
                }}
              />
            </div>
          ) : (
            <Table>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>ID Pedido</th>
                  <th>Saldo Anterior</th>
                  <th>Tipo</th>
                  <th>Valor</th>
                  <th>Saldo Atual</th>
                  <th>Cliente</th>
                  <th>Funcionário</th>
                </tr>
              </thead>
              <tbody>
                {historico.map((data) => (
                  <tr key={data.id}>
                    <td>{data.id}</td>
                    <td>{data.id_pedido || 'Sem Pedido'}</td>
                    <td>{formatPrice(data.saldo_anterior || 0)}</td>
                    <td
                      style={{
                        fontWeight: 'bold',
                        color: data.tipo.trim() === 'saida' ? 'red' : 'green',
                      }}
                    >
                      {String(data.tipo).toUpperCase()}
                    </td>
                    <td>{formatPrice(data.valor || 0)}</td>
                    <td>{formatPrice(data.saldo_atual || 0)}</td>
                    <td>{data.nome_cliente}</td>
                    <td>{data.nome_funcionario}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </Modal.Body>
      </Modal>
    )
  },
)
